import React, { useCallback, useEffect, useState } from 'react'
import { getCustomerInfo } from '../../../actions/customerActions';
import Fade from '@material-ui/core/Fade';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import { Button, Col, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Transactions from './_components/Transactions';
import Clicks from '../../clicks';
import Payments from '../../payment/Payments';
import CustomerInfoMix from './_components/CustomerInfoMix';
const CustomerTableInfoUser = ({ match: { params } }) => {

    const [data, setData] = useState({});
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalTitle, setModalTitle] = useState('');
    const [modalContent, setModalContent] = useState(null);

    const handleCustomer = useCallback(async (params) => {
        setLoading(true)
        const response = await getCustomerInfo(params);
        setData(response);
        setLoading(false);
    }, []);

    const closeModal = useCallback(() => {
        setModalOpen(false);
        setModalTitle('');
        setModalContent(null);
    }, []);

    useEffect(() => {
        handleCustomer(params)
        return () => setLoading(false);
    }, [handleCustomer, params]);

    return (
        <div className='row'>
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                id="modal"
                aria-labelledby="transition-modal-title"
                aria-describedby="transition-modal-description"
                open={modalOpen}
                onClose={closeModal}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={modalOpen}>
                    <div className="material-modal-content">
                        <h4 id="transition-modal-title">
                            {modalTitle}
                            <FontAwesomeIcon
                                icon="times"
                                className="cursor-pointer float-right"
                                onClick={closeModal}
                            />
                        </h4>
                        <div id="transition-modal-description">
                            {modalContent}
                        </div>
                    </div>
                </Fade>
            </Modal>

            <CustomerInfoMix dataCustomer={data} bankId={params.bank_id} onRefetch={() => handleCustomer(params)} />

            {

                data?.id && (
                    <>
                        <Transactions customerId={data?.id} />


                        <Col xs="12" lg="12" className='mt-5'>
                            <Clicks customerId={data?.id} />
                            <Payments customerId={data?.id} />
                        </Col>
                    </>
                )

            }





        </div>

    )
}

export default CustomerTableInfoUser;